var map = {
	"./acolman.jpg": "8cfd",
	"./aguaacolman.jpg": "a982",
	"./aguaaculco.jpg": "15b9",
	"./aguacalimaya.jpg": "b0ac",
	"./aguachalco.jpg": "d638",
	"./aguachicoloapan.jpg": "01f4",
	"./aguahuixquilucan.jpg": "6f78",
	"./aguahuixquilucan_ANT.jpg": "4fed",
	"./aguahuixquilucanx.jpg": "f7a4",
	"./aguaixtapandelasal.jpg": "b723",
	"./aguateotihuacan.jpg": "d3f4",
	"./demo01.jpg": "e984",
	"./huehuetoca.jpg": "22e2",
	"./ixtlahuaca.jpg": "f89f",
	"./polotitlan.jpg": "54d0",
	"./portadaagua.jpg": "3974",
	"./tultepec.jpg": "c0b2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9bdb";